export default __webpack_public_path__ + "static/throw-97b169da44947d2e7c3a83145c25e1e0.webp";